<div class="container-fluid">
	<div class="row align-items-center mb-3">
		<div class="col-12">
			<seira-page-title class="w-100 align-items-center">
				<div class="d-flex justify-content-between align-items-center">
					<div
						style="
							color: #728187;
							font-weight: 400;
							font-size: 24px !important;
						">
						Dados meteorológicos
						<i class="dot bg-primary dot-space"></i>
						Envio de dados massivos
					</div>
					<div class="d-flex justify-content-end">
						<seira-public-page-about
							class="size-about"
							[textosInformativos]="
								informacoesGerais
							"></seira-public-page-about>
					</div>
				</div>
			</seira-page-title>
		</div>
	</div>

	<form [formGroup]="form" class="form-group">
		<div class="row">
			<div class="col-12 col-lg-4">
				<div class="row">
					<div class="col-12 mt-2">
						<seira-public-input
							[showsTextRequired]="conditionShowTextRequired('nome')"
							[required]="true"
							type="text"
							controlName="nome"
							label="Nome"
							placeholder="Informe o seu nome"
							id="nome_form"></seira-public-input>
						<small
							class="text-danger mt-1"
							*ngIf="
								form.get('nome')?.hasError('required') &&
								form.get('nome')?.touched
							">
							Campo obrigatório.
						</small>
					</div>
					<div class="col-12 mt-2">
						<seira-public-input
							[showsTextRequired]="conditionShowTextRequired('email')"
							[required]="true"
							type="email"
							controlName="email"
							label="E-mail"
							placeholder="Informe o seu e-mail para receber os dados"
							id="email_form"></seira-public-input>
						<ng-container *ngIf="emailControl?.touched">
							<small
								class="text-danger mt-1"
								*ngIf="emailControl?.hasError('required')">
								Campo obrigatório.
							</small>
							<small
								class="text-danger mt-1"
								*ngIf="emailControl?.hasError('email')">
								E-mail inválido.
							</small>
						</ng-container>
					</div>
					<div class="col-12 mt-2 flex-wrap">
						<seira-public-radio-group
							idRadio="modo"
							[options]="opcoesModo"
							label="Tipo de estação"
							[isDesabilitado]="loadingForm"
							controlName="tipoModo" />
					</div>

					<div class="col-12 mt-2">
						<seira-public-select
							[required]="true"
							label="Variáveis"
							placeholder="Selecione..."
							formControlName="variavel"
							[optionLabel]="'name'"
							[optionValue]="'value'"
							[carregando]="loadingForm"
							[multiple]="true"
							[maxShownValues]="3"
							[options]="variaveis">
						</seira-public-select>

						<small
							class="text-danger mt-1"
							*ngIf="
								form.get('variavel')?.hasError('required') &&
								form.get('variavel')?.touched
							">
							Campo obrigatório.
						</small>
					</div>
					<div class="col-12 mt-2">
						<seira-public-radio-group
							label="Tipo de dados"
							[controlName]="FormularioRelatorio.PERIODO_BUSCA"
							[isDesabilitado]="loadingForm"
							[options]="opcoesPeriodo" />
					</div>
					<div class="row mt-2 gx-2">
						<div class="col-12 col-md-6">
							<seira-public-date-picker
								class="w-100 mt-2"
								[required]="true"
								[minDate]="dataMinimaSudene"
								[maxDate]="dataMaximaPicker"
								controlName="dataInicio"
								[label]="'Data inicial'"
								[placeholder]="'Informe a data inicial'"
								[readonly]="true"
								[datePickerType]="datePickerType"
								[isDesabilitado]="loadingForm">
							</seira-public-date-picker>

							<small
								class="text-danger mt-1"
								*ngIf="
									this.form.get('dataInicio')?.touched &&
									this.form.get('dataInicio')?.hasError('required')
								">
								Campo obrigatório.
							</small>
						</div>

						<div class="col-12 col-md-6">
							<seira-public-date-picker
								class="w-100 mt-2"
								[required]="true"
								[minDate]="dataFimMinima"
								[maxDate]="dataMaximaPicker"
								controlName="dataFim"
								[readonly]="true"
								[label]="'Data final'"
								[placeholder]="'Informe a data final'"
								[datePickerType]="datePickerType"
								[isDesabilitado]="loadingForm">
							</seira-public-date-picker>

							<small
								class="text-danger mt-1"
								*ngIf="
									this.form.get('dataFim')?.touched &&
									this.form.get('dataFim')?.hasError('required')
								">
								Campo obrigatório.
							</small>
						</div>
					</div>
				</div>
			</div>

			<div class="col-12 col-lg-8 mt-2">
				<seira-transfer-list
					#transferListComponent
					[inputList]="postosDisponiveis"
					[(outputList)]="postosSelecionados"
					[loading]="loadingForm"
					[disabled]="loadingForm"
					[required]="true"
					[inputLabelClass]="'text-tertiary-light fw-normal font-size-16 mb-2'"
					inputLabel="Estações"
					formControlName="estacao"
					[outputLabel]="'Estações selecionadas'"></seira-transfer-list>
			</div>

			<div class="col-12 mt-4">
				<seira-public-button
					[loading]="loadingForm"
					(clicked)="abrirModalConfirmacaoEmail()"
					>Enviar solicitação</seira-public-button
				>
			</div>
		</div>
	</form>
	<div
		class="d-flex w-100 justify-content-start mt-4"
		*seiraIfViewportSize="'desktop'">
		<div class="col-lg-6">
			<seira-info-gerais
				id="informacoes-gerais"
				[textosInformativos]="informacoesGerais"></seira-info-gerais>
		</div>
	</div>
</div>
